import React, { useState } from 'react';
import { StyledToolbarButton, StyledTooltip } from '../../../shared/styles/components/integrations.styles';

import { EmissionFactorModal } from './EmissionFactorModal';
import leafIcon from '@ingka/ssr-icon/paths/leaf';
import { useAuth } from '../../auth/state/auth.state';

interface EmissionFactorButtonProps {
   materialGradeId?: string;
}

export const EmissionFactorButton = ({ materialGradeId }: EmissionFactorButtonProps): JSX.Element => {
   const { canManageEmissionFactors } = useAuth();
   const [isModalOpen, setIsModalOpen] = useState(false);

   return (
      <>
         <StyledTooltip title="Manage emission factors">
            <span>
               <StyledToolbarButton
                  ssrIcon={leafIcon}
                  text="Emission Factors"
                  iconOnly
                  small
                  onClick={() => setIsModalOpen(true)}
               />
            </span>
         </StyledTooltip>

         {isModalOpen && (
            <EmissionFactorModal
               visible={isModalOpen}
               onClose={() => setIsModalOpen(false)}
               materialGradeId={materialGradeId}
               canEditEmissionFactors={canManageEmissionFactors}
            />
         )}
      </>
   );
};